module.exports = __webpack_public_path__ + "static/media/logo.84db5052.svg";